// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oBJk","importantInfo":"styles_importantInfo__3imGJ"};